
import axios from 'axios'
import QS from 'qs'

export default class BaseService{
    constructor(options){
        options = options||{};
        this.$http = axios;
        this.baseUrl = options.baseUrl||"";

        this.init(options);
        if(this.baseUrl.length>0){
            this.baseUrl=this.baseUrl.endsWith("/")?this.baseUrl:(this.baseUrl+"/");
        }
    }

    init(options){

    }

    static formatUrl(url){
        return new BaseService().getUrl(url);
    }
    getUrl(url){
        url += "";
        if(url.indexOf("/")===0){
            return url;
        }
        if(url.indexOf(this.baseUrl)===0) return url;
        return this.baseUrl + url;
    }

    post(url,data,config){
        if(config){
            if(config.isForm){
                config = {...config,...{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        transformRequest: [function (data) {
                            return QS.stringify(data);
                        }],
                    }}
            }
            return this.$http.post(this.getUrl(url),data,config);
        }else{
            return this.$http.post(this.getUrl(url),data);
        }
    }

    postForm(url,data,config){
        config = config||{};
        config.isForm = true;
        return this.post(url,data,config);
    }

    get(url,config){
        return this.$http.get(this.getUrl(url),config);
    }

    getData(id){
        return this.get(`${id}`,{});
    }

    getByIds( ids ){
        return this.post( "",{ids:ids})
    }

    delete(url,config){
        return this.$http.delete(this.getUrl(url),config);
    }

    deleteData(id){
        return this.delete(`${id}`,{});
    }

    remove(id){
        return this.delete(`${id}`,{});
    }

    add(  data ){
        return this.submit("",data);
    }

    save( id , data ){
        return this.submit(`${id||''}`,data);
    }


    submit( url , data ){
        let d = this.submitBegin(url,data);
        return this.post(url,d);
    }

    submitBegin(url,data){
        return data;
    }

    find( params ){
        return this.postForm("find",params);
    }

    page( params ){
        return this.postForm("page",params);
    }
    
    expand(ls,level){
        if(level<2) return;
        level--;
        ls.forEach((o)=>{
            o.expand = true;
            if(o.children&&o.children.length){
                this.expand(o.children,level);
            }
        })
    }

}
